// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainPageCard{
    border-bottom: 1px solid var(--lightBlue);
    border-top: 1px solid var(--lightBlue);
    padding: 10px 25px;
    background-color: #fff;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}


/* ------------------- Media Query ------------------------- */

@media (max-width: 700px) {
    .mainPageCard{
        padding: 10px 10px;
    }
    .mainPageCard > :nth-child(2) p{
       font-size: 14px !important;
    }
    .mainPageCard > :nth-child(2) svg{
      width: 20px;
      height: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/components.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;;AAGA,8DAA8D;;AAE9D;IACI;QACI,kBAAkB;IACtB;IACA;OACG,0BAA0B;IAC7B;IACA;MACE,WAAW;MACX,YAAY;IACd;AACJ","sourcesContent":[".mainPageCard{\n    border-bottom: 1px solid var(--lightBlue);\n    border-top: 1px solid var(--lightBlue);\n    padding: 10px 25px;\n    background-color: #fff;\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n\n/* ------------------- Media Query ------------------------- */\n\n@media (max-width: 700px) {\n    .mainPageCard{\n        padding: 10px 10px;\n    }\n    .mainPageCard > :nth-child(2) p{\n       font-size: 14px !important;\n    }\n    .mainPageCard > :nth-child(2) svg{\n      width: 20px;\n      height: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
